// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible.js'
import vueSwiper from 'vue-awesome-swiper'  //引入vue-awesome-swiper
import 'swiper/swiper-bundle.css'
import BaiduMap from 'vue-baidu-map'

import {get, post} from './service.js'
Vue.prototype.$get=get
Vue.prototype.$post = post

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Carousel3d from 'vue-carousel-3d';
Vue.use(Carousel3d);


import scroll from 'vue-seamless-scroll'
Vue.use(scroll)


Vue.use(BaiduMap,{
  ak:'F1fNKwPGMHZotlONGc9atmh0LBProFHi'
})

Vue.config.productionTip = false
Vue.use(vueSwiper)  //使用插件
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js